import { Fields } from '@hako/core'
import Cookies from 'js-cookie'
import { useState } from 'react'

export const CookieBar = () => {
    const [isVisible, setIsVisible] = useState(!Cookies.get('cookiebar'))
    const handleConfirm = () => {
        Cookies.set('cookiebar', 1, { expires: 365 })
        setIsVisible(false)
    }

    if (!isVisible) {
        return null
    }

    return (
        <div className="section cookie-banner grid grid-column-start-1 grid-column-end-13 grid-column-tablet-start-1 grid-column-tablet-end-9 grid-column-mobile-start-1 grid-column-mobile-end-5 u-padding-top-medium u-padding-bottom-medium">
            <div className="grid-container grid u-justify-content-space-between u-align-items-center row-gap-small">
                <div className="grid-column-start-1 grid-column-end-9 grid-column-tablet-start-1 grid-column-tablet-end-7 grid-column-mobile-start-1 grid-column-mobile-end-5">
                    <Fields.Text
                        as="p"
                        className="paragraph paragraph--small u-margin-none"
                        scope="global"
                        slug="cookie-notification-text"
                    >
                        We use cookies to offer you a convenient web browsing
                        experience, to suggest personalized ads for you, and to
                        keep improving functions through traffic analysis. By
                        accepting you consent to our use of cookies.
                    </Fields.Text>
                </div>
                <div className="grid-column-start-10 grid-column-end-13 grid-column-tablet-start-7 grid-column-tablet-end-9 grid-column-mobile-start-1 grid-column-mobile-end-5 u-flex-row u-align-items-center u-justify-content-flex-end">
                    <button
                        className="btn btn--small btn--outline u-margin-left-small u-margin-right-small js-cookie-banner-accept"
                        onClick={handleConfirm}
                    >
                        <Fields.Text
                            as="span"
                            scope="global"
                            slug="button-accept"
                        >
                            Accept
                        </Fields.Text>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default CookieBar
